module.exports = function(gantt) {
};


//////////////////
// WEBPACK FOOTER
// ./sources/core/dynamic_loading.gpl.js
// module id = 67
// module chunks = 0